import React from "react";
import moment from "moment";
import { NumberField, TextField } from "Utils/renderField/fieldsHookForms";
import NullableValue from "../../../../../../../Utils/renderField/nullableValue";
import { RenderNumber } from "../../../../../../../Utils/renderField/renderReadField";
const alertaIcon = require("assets/img/icons/alerta_roja.png");
const eliminarIcon = require("assets/img/icons/borrar.png");

const aNumero = (valor) => {
    if (valor === "" || valor === null || valor === undefined) return 0;

    return Number(valor);
};

export const ReajustePacasTable = ({ hook, onEliminar }) => {
    const { formControl, formErrors, lineas, GuardarReajustePallet } = hook;

    return (
        <div className="new-table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>No. de pallet</th>
                        <th>Identificador físico</th>
                        <th>Pacas registradas</th>
                        <th>Pacas reales</th>
                        <th>Diferencia</th>
                        <th>Observaciones</th>
                        <th>Responsable</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {lineas.length === 0 && (
                        <tr>
                            <td colSpan={8} className="text-center">
                                No hay pallets con existencia de este producto y
                                condición
                            </td>
                        </tr>
                    )}
                    {lineas.map((linea, index) => {
                        // negativa cuando al pallet le faltan pacas contra lo
                        // que el sistema tiene registrado
                        const diferencia =
                            linea.reajuste_id !== null &&
                            linea.reajuste_id !== undefined
                                ? aNumero(linea.pacas_nuevas) -
                                  aNumero(linea.pacas_actuales)
                                : 0;

                        return (
                            <tr
                                key={
                                    linea.pallet_id
                                        ? `pallet-${linea.pallet_id}`
                                        : `nuevo-${linea.reajuste_id}`
                                }
                            >
                                <td
                                    className="text-center text-nowrap"
                                    title={
                                        linea.numero
                                            ? ""
                                            : "El número de pallet se asigna " +
                                              "al cerrar el inventario"
                                    }
                                >
                                    {linea.numero || "Por crear"}
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={linea.identificador_fisico}
                                    >
                                        {linea.identificador_fisico || ""}
                                    </NullableValue>
                                </td>
                                <td className="text-right text-nowrap">
                                    <RenderNumber
                                        value={linea.pacas_actuales}
                                        decimalScale={0}
                                    />
                                </td>
                                <td className="reajuste-pacas__celda-editable">
                                    <NumberField
                                        control={formControl}
                                        errors={formErrors}
                                        name={`lineas.${index}.pacas_reales`}
                                        decimalScale={0}
                                        className="text-right"
                                        onBlur={() =>
                                            GuardarReajustePallet(linea, index)
                                        }
                                    />
                                </td>
                                <td
                                    className={`text-right text-nowrap ${
                                        diferencia !== 0 ? "text-danger" : ""
                                    }`}
                                >
                                    <RenderNumber
                                        value={diferencia}
                                        decimalScale={0}
                                    />
                                </td>
                                <td className="reajuste-pacas__celda-editable">
                                    <TextField
                                        control={formControl}
                                        errors={formErrors}
                                        name={`lineas.${index}.observaciones`}
                                        onBlur={() =>
                                            GuardarReajustePallet(linea, index)
                                        }
                                    />
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue value={linea.usuario_nombre}>
                                        <React.Fragment>
                                            {linea.usuario_nombre || ""}
                                            {linea.fecha_modificacion && (
                                                <div className="reajuste-pacas__fecha">
                                                    {moment(
                                                        linea.fecha_modificacion,
                                                    ).format(
                                                        "DD/MM/YYYY HH:mm",
                                                    )}
                                                </div>
                                            )}
                                        </React.Fragment>
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue value={linea.reajuste_id}>
                                        <div className="table-actions">
                                            {linea.obsoleto && (
                                                <img
                                                    src={alertaIcon}
                                                    alt="Desactualizado"
                                                    className="action_img"
                                                    title={
                                                        "La existencia de este " +
                                                        "pallet cambió después de " +
                                                        "registrar el reajuste. " +
                                                        "Vuelva a ingresar las " +
                                                        "pacas reales."
                                                    }
                                                />
                                            )}
                                            {linea.reajuste_id && (
                                                <img
                                                    src={eliminarIcon}
                                                    alt="Eliminar reajuste"
                                                    className="action_img"
                                                    title="Eliminar reajuste"
                                                    onClick={() =>
                                                        onEliminar(linea)
                                                    }
                                                />
                                            )}
                                        </div>
                                    </NullableValue>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
